import { SUBTABS, TRY_STEPS } from './ConstPaths';
import { Link } from 'react-router-dom';

//the first method category is used to narrow down the general category 
//for what the user wants to try in a test-drive.
//Relates to the first question in the Test-drive. 
//It's *not* a category like head tracker, switch, keyboard.
export const FIRST_METHOD_CATEGORY = {
  CURRENT: 'current-method',
  PAST: 'past-method',
  STANDARD: 'standard-method',
  ANY: 'any-method'
};

export const LABELS_FOR_SETUP = {
  ACCESS_METHOD: 'Access method',
  SELECTION_METHOD: 'Selection method',
  BODY_SITES: 'Body sites',
  BODY_SITE_COMMENTS: 'Body site comments',
  ACCESSORIES: 'Accessories',
  POSITIONING: 'Positioning notes',
  OTHER: 'Other setup notes',
  NAME: 'Name for this setup'
}
export const TEST_DRIVE_ACTIVITIES = {
  OWN_ACTIVITY: 'own-activity',
  POINTING_BASIC: 'pointing-basic',
  TEXT_ENTRY_BASIC: 'text-entry-basic',
  SWITCH_BASIC: 'switch-basic'
};

export const DEFAULT_TEXTS_IN_TEST = 4;
export const DEFAULT_TARGETS_IN_TEST = 10;
export const DEFAULT_HITS_IN_TEST = 8;
export const NUM_PRACTICE_TRIALS = 3;
export const DEFAULT_TARGET_SIZE = 40;


export const TEXT_LANGUAGES = {
  EN: 'English',
  ES: 'Spanish',
  FR: 'French',
  PTBR: 'Portuguese'
}
export const DEFAULT_TEXT_LANGUAGE = TEXT_LANGUAGES.EN;

export const TEXT_UNITS = {
  SENT: 'Sentence',
  WORD: 'Word',
  LTR: 'Letter'
}
export const DEFAULT_TEXT_UNIT = TEXT_UNITS.SENT;

export const TARGET_TYPES ={
  CIRCLE: 'Circle',
  SMILEY: 'Smiley'
}
export const DEFAULT_TARGET_TYPE = TARGET_TYPES.CIRCLE;

//these are used as CSS class names to display different states
export const SWITCH_TRIAL_STATES = {
  PRESS: 'aa-show-press',
  RELEASE: 'aa-show-release',
  SUCCESS: 'aa-show-success',
  PRE_TRIAL_RELEASE: 'aa-show-pretrial-release',
  PRE_TRIAL_PAUSE: 'aa-show-pretrial-pause',
};

export function OwnActivityInstructions(props){
  const {
    firstName,
    pronouns
  } = props;
  return(
    <div>
      <p>Once everything is in position and connected properly, give {firstName} some basic instructions
        to orient {pronouns[1]} to the activity.
      </p>
    </div>
  );
}

export function TextEntryBasicInstructions(props){
  return(
    <div>
      <p>Now that everything is in position and connected properly, here are some basic instructions for the basic Text Entry activity.</p>
      <ol>
        <li>A short sentence will appear on the screen. (If you want to use words or letters instead, use the Change Settings button.)</li>
        <li>Try to copy that sentence exactly.</li>
        <li>Hit the Enter key when you are done with the sentence.</li>
        <li>Keep going until no more sentences appear.</li>
        <li>You can stop early if you want.</li>
      </ol>
    </div>
  );
}

export function PointingBasicInstructions(props){
  return(
    <div>
      <p>Now that everything is in position and connected properly, here are some basic instructions for the basic Pointing activity.</p>
      <ol>
        <li>A circle will appear on the screen.</li>
        <li>Move the mouse cursor into the circle.</li>
        <li>Then click the mouse button to select the circle.</li>
        <li>Keep going until no more circles appear.</li>
        <li>You can stop early if you want.</li>
      </ol>
    </div>
  );
}

export function SwitchBasicInstructions(props){
  return(
    <div>
      <p>Now that everything is in position and connected properly, here are some basic instructions for the basic Switch activity.</p>
      <ol>
        <li>A circle will appear on the screen.</li>
        <li>Activate your switch when the circle appears.</li>
        <li>If switch sends a mouse click, make sure the cursor is within the gray shaded area.</li>
        <li>Keep going until no more circles appear.</li>
        <li>You can stop early if you want.</li>
      </ol>
    </div>
  );
}

export function DefaultActivityInstructions(props){
  const {
    firstName,
    pronouns
  } = props;

  const act_path = SUBTABS.TRY + "/" + TRY_STEPS.ACTIVITY;

  return(
    <div>
      <p><strong>Note:</strong> It looks like you didn't pick an activity type.</p>
      <p>We recommend that you <Link to={act_path}>select an activity type</Link> first. It helps us (and you!) keep track of multiple activities with less confusion.</p>
      <p>But you can continue without selecting an activity type, if you want to. Essentially it will be an unofficial way of running your own activity.</p>
      <p>Here are some generic instructions:</p>
      <ul>
        <li>Decide on an activity that you and {firstName} want to do</li>
        <li>Once everything is in position and connected properly, give {firstName} some basic instructions
        to orient {pronouns[1]} to the activity.</li>
      </ul>
    </div>
  );
}

export function getYourActivityBtns(firstName) {
  firstName = firstName || "the client";
  return(
    [
      {
        value: TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY,
        label: `Your own activity`,
        sublabel: `Something ${firstName} enjoys`,
        text: `Set up an activity that lets ${firstName} try out this access method, either on this computer, on another device, or completely no-tech.`,
        moreInfo: ''
      }
    ]
  );
}
export function getTextActivityBtns(firstName) {
  firstName = firstName || "the client";
  return(
    [
      {
        value: TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC,
        label: `Text entry`,
        sublabel: `In-app activity`,
        text: `Presents text for ${firstName} to copy using this access method.`,
        moreInfo: ''
      }
    ]
  );
}
export function getPointingActivityBtns(firstName) {
  firstName = firstName || "the client";
  return(
    [
      {
        value: TEST_DRIVE_ACTIVITIES.POINTING_BASIC,
        label: `Point and click`,
        sublabel: `In-app activity`,
        text: `Presents targets for ${firstName} to select with this access method.`,
        moreInfo: ''
      }
      ]
  );
}
export function getSwitchActivityBtns(firstName) {
  firstName = firstName || "the client";
  return(
    [
      {
        value: TEST_DRIVE_ACTIVITIES.SWITCH_BASIC,
        label: `Switch hit`,
        sublabel: `In-app activity`,
        text: `Asks ${firstName} to activate switch in response to a prompt.`,
        moreInfo: ''
      }
    ]
  );
}

//return an array of all the activity buttons, across all categories
function extractActivityButtons(){
  let activityBtns = [];
  let yaBtns = Object.values(getYourActivityBtns()).flat();
  let textBtns = Object.values(getTextActivityBtns()).flat();
  let pointingBtns = Object.values(getPointingActivityBtns()).flat();
  let switchBtns = Object.values(getSwitchActivityBtns()).flat();
  activityBtns = yaBtns.concat(textBtns, pointingBtns,switchBtns);
  return activityBtns;
}

export function getActivityLabelForValue(value){
  let activityBtns = extractActivityButtons();
  let matchingLabel = "";
  activityBtns.forEach(a => {
    if(a.value === value)
      matchingLabel = a.label;
  })
  return matchingLabel;
}

export function isBuiltInActivity(activity) {
  let builtIn = false;
  if (activity && 
      (activity === TEST_DRIVE_ACTIVITIES.POINTING_BASIC
        || 
        activity === TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC
        ||
        activity === TEST_DRIVE_ACTIVITIES.SWITCH_BASIC
      )){
    builtIn = true;
  }
  return builtIn;
} 

const TD_TRY_OBSERVATION_HELP = `
  <ul>
    <li>Accuracy - the level of control that the access method provides to the client</li>
    <li>Ease of use</li>
    <li>Safety - comfortable, pain-free, stable and appropriate body postures</li>
    <li>Efficiency - how quickly can the client accomplish the task</li>
    <li>Consistency - is there a lot of variability in performance? Is it getting worse over time? Or better?</li>
    <li>Client's affect - do they seem to be engaged? Enjoying it? Confused? etc.</li>
  </ul>
`;

export const TD_TRY_START_HELP = `
  <div>
    <p>During a Test-drive activity, you can note any observations that seem relevant. This might include things like: </p>
    ${TD_TRY_OBSERVATION_HELP}
  </div>
`;

export const TD_TEXT_ENTRY_HELP = `
  <div>
    <h4>Basic typing activity</h4>
    <p>In this activity, you type a set of sentences, one at a time. You can edit the text as usual. The activity ends after a set number of sentences (or when you click End Activity, to end early).</p>
    <h5>Results</h5>
    <ul>
      <li>Speed - typing speed in correct words per minute, averaged across the whole activity.  This counts the characters that are correct at the end of the sentence, then divides that by 5 to get correct words.</li>
      <li>Accuracy - the percent of characters that were selected correctly, averaged across the whole activity.</li>
      <br />
      <li>Time Taken - the number of seconds required to enter the sentence. (Excludes time for the very first character and for the Enter key.)</li>
      <li>Raw speed - raw typing speed, not adjusted for errors. Counts all characters entered, then divides by 5 to get raw words entered.</li>
      <li>Correct speed - typing speed in correct words per minute. This counts the characters that are correct at the end of the sentence, then divides that by 5 to get correct words.</li>
    </ul>
    <h5>Observations</h5>
    ${TD_TRY_START_HELP}
  </div>
`;

export const TD_POINTING_HELP = `
  <div>
    <h4>Basic point-and-click activity</h4>
    <p>In this activity, a series of circle targets appear on the screen, one at a time. The client clicks on each circle to select it. The activity ends after a set number of circles (or when you click End Activity, to end early).</p>
    <h5>Results</h5>
    <ul>
      <li>Speed - the average number of targets per minute selected, across the entire activity</li>
      <li>Accuracy - the percent of targets selected with exactly one click (i.e., on the first try)</li>
      <br />
      <li>Time Taken - the number of seconds required to select a target</li>
      <li>Entries - the number of times the cursor entered the target. (The cursor must enter at least once to select the target.)</li>
      <li>Clicks - the number of clicks that occurred (whether by physical click or dwell, inside or outside of the circle). 1 inside click is necessary to select the target.</li>
    </ul>
    <h5>Observations</h5>
    ${TD_TRY_START_HELP}
  </div>
`;

export const TD_SWITCH_HELP = `
  <div>
    <h4>Basic switch activity</h4>
    <p>In this activity, a series of prompt circles appear on the screen, one at a time. When each prompt appears, the client hits their switch in response. The activity ends after a set number of prompts (or when you click End Activity, to end early). (Note: If the switch sends a mouse click, make sure the cursor is within the gray shaded area.)</p>
    <h5>Results</h5>
    <ul>
      <li>Difficulty score - an overall indicator of how well the current switch setup meets your needs: low, medium, or high difficulty.</li>
      <br />
      <li>Switch - this shows what the switch 'sent' to the activity. It could be 'Click' for a mouse button click, or any keyboard character (like 'Space' or 'a'). This can be helpful for seeing what's going on behind the scenes when troubleshooting.</li>
      <li>Reaction Time - how long it took for the user to press the switch, after the prompt appeared. In seconds.</li>
      <li>Hold Time - how long the user held the switch down. Measured from first press to first release. In seconds.</li>
      <li>Trial Time - total time to press-and-release the switch after the prompt appears. Reaction Time + Hold Time. In seconds.</li>
      <li>Extra Hits - the number of switch hits that occurred before the prompt appeared</li>
    </ul>
    <h5>Observations</h5>
    ${TD_TRY_START_HELP}

  </div>
`;

export const TD_GENERAL_HELP = `
  <div>
    <h4>Your own activity</h4>
    <p>Here you're doing an activity of your own choosing, outside of Access Navigator. (Later, you can always try one of the in-app activities, built-in to Access Navigator, if you want.)</p>
    <p>So we don't know what sorts of results are most meaningful for this activity. But whatever they are, you can enter them into the Observations if you'd like.</p>
    <h5>Observations</h5>
    ${TD_TRY_START_HELP}
  </div>
`;

export const TD_DIFFICULTY_SCORE_HELP = `
  <div>
    <h5>What does the Difficulty Score mean?</h5>
    <p>Your score is one indicator of how well the current switch setup meets your needs. It combines indicators of speed, consistency, and precision into one overall score. A higher score suggests greater difficulty with using the switch, while a lower score indicates lower difficulty.</p>
    <p>We categorize your score as indicating low, medium, or high difficulty, based on research with people who use switches.<p>
    <p>For example, a score in the low difficulty range suggests that your use of the current switch setup is appropriate for effective use of scanning.</p>
    <p>If your score is in the medium or high difficulty range, it may just mean that this switch setup isn't a great fit for you.  It may improve with practice, or you may want to make adjustments to see if the difficulty decreases.</p> 
    <h5>How is my score calculated?</h5>
    <p>To calculate the Difficulty Score, we add the average Trial Time, the standard deviation of Trial Time, and the average Extra Hits.</p>
    <p>Trial Time is the time between the start and end of each switch trial. It indicates speed, where a smaller time means faster speed.</p>
    <p>Standard Deviation of Trial Time reflects consistency. A lower standard deviation means higher consistency.</p>
    <p>Extra Hits are switch hits beyond the one hit required for the trial. This is an indicator of precision, where fewer extra hits mean higher precision.</p>
  </div>
`;


